import {getUserName, isIpAddress, isSsoUser, isUserAdmin} from "@/helpers/auth/auth-helper";

export function checkAdfs(setting) {

    let redirect = '../' + window.location.search
    if(window.location.origin && window.kaartViewerUrl) {
        redirect = window.location.href
    }

    let replaceUrl = window.kaartViewerUrl + "/admin/rest/auth/myself?loginType=1&source=" + setting + '&redirect=' + redirect;

    if(
        isSsoUser() === 'false' &&
        setting !== ''
        && isUserAdmin() === 'false'
        &&
        (getUserName() === '' || getUserName() === undefined)
    ) {
        window.isAdfs = true

        window.location.replace(replaceUrl + '&nd=' + new Date().getTime());
    }
}
